import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd';
var collectors = {
  source: function source(connect, monitor) {
    return {
      dragging: monitor.isDragging(),
      dragSource: connect.dragSource()
    };
  },
  target: function target(connect, monitor) {
    return {
      hovering: monitor.isOver(),
      dropTarget: connect.dropTarget()
    };
  }
};
var specs = {
  source: {
    beginDrag: function beginDrag(props) {
      return {
        index: props.index
      };
    },
    endDrag: function endDrag(props, monitor) {
      if (monitor.didDrop()) {
        var source = props.index;
        var target = monitor.getDropResult().index;
        if (source !== target) {
          props.onItemsSort(source, target);
        }
      }
    }
  },
  target: {
    drop: function drop(props) {
      return {
        index: props.index
      };
    }
  }
};
export var SortableItem = /*#__PURE__*/function (_Component) {
  function SortableItem() {
    var _this;
    _classCallCheck(this, SortableItem);
    _this = _callSuper(this, SortableItem, arguments);
    _this.componentDidUpdate = function (prevProps) {
      var prevDragging = prevProps.dragging,
        prevHovering = prevProps.hovering;
      var _this$props = _this.props,
        dragging = _this$props.dragging,
        hovering = _this$props.hovering,
        index = _this$props.index,
        onItemDrag = _this$props.onItemDrag,
        onItemHover = _this$props.onItemHover;
      if (prevDragging !== dragging) {
        onItemDrag(index, dragging);
      }
      if (prevHovering !== hovering && !prevDragging) {
        onItemHover(index, hovering);
      }
    };
    return _this;
  }
  _inherits(SortableItem, _Component);
  return _createClass(SortableItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        dragSource = _this$props2.dragSource,
        dropTarget = _this$props2.dropTarget,
        children = _this$props2.children;
      return dragSource(dropTarget(children));
    }
  }]);
}(Component);
export default dragSource('ITEM', specs.source, collectors.source)(dropTarget('ITEM', specs.target, collectors.target)(SortableItem));